import axios from 'axios';
import Cookies from 'js-cookie';
import {useCallback, useEffect, useState} from 'react';
import {APIURL} from '../../../consts';
import {Language} from '../../../context/LanguageContext';
import {DoughnutChart, RightDropdown} from '../..';
import {IconMail, IconProfile, IconTelephone, Profile} from '../../../assets';
import {Box, Grid} from '@material-ui/core';
import '../../../assets/styles/patd.scss';
export default function PolyphiaATD({
  zoomer,
  projectCode,
  pkCode,
  negeriCode,
  wilayahCode,
  mapRef,
}) {
  const [payload, setPayload] = useState({
    tahun: {
      label: '',
      value: '',
    },
    jenisTanaman: 'sawit',
  });
  const {newObj, language} = Language();
  const [data, setData] = useState({
    ph: null,
    npk: null,
    pengesyoran_baja: null,
  });
  const [title, setTitle] = useState('');
  const [picData, setPicData] = useState({});
  const [years, setYears] = useState([]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    responsiveAnimationDuration: 0,
    aspectRatio: 1,
    width: '100%',
    plugins: {
      legend: {
        display: false, // set this to false to hide the legend
      },
    },
  };
  const getPh = useCallback(
    async (payload) => {
      try {
        const response = await axios.post(APIURL.atd_ph_get_data, payload, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${Cookies.get('token')}`,
          },
        });
        setData((prev) => ({...prev, ph: response.data.data}));
        setPicData(response.data.pic);
        setTitle(response.data.payload.nama);
      } catch (error) {}
    },
    [mapRef]
  );

  const getNpk = useCallback(
    async (payload) => {
      try {
        const response = await axios.post(APIURL.atd_npk_get_data, payload, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${Cookies.get('token')}`,
          },
        });
        setData((prev) => ({...prev, npk: response.data.data}));
        setPicData(response.data.pic);
        setYears(
          response.data.years.map((item) => ({label: item, value: item}))
        );
      } catch (error) {}
    },
    [mapRef]
  );

  const getSyor = useCallback(async () => {
    try {
      const url =
        payload.jenisTanaman === 'sawit'
          ? APIURL.syor_sawit_list
          : APIURL.syor_getah_list;
      const response = await axios.post(
        url,
        {tahun: payload.tahun.value, kodProjek: projectCode},
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${Cookies.get('token')}`,
          },
        }
      );
      setData((prev) => ({...prev, pengesyoran_baja: response.data.data}));
    } catch (error) {}
  }, [payload]);

  useEffect(() => {
    // let projectCodeSlice = null;
    // if (projectCode) {
    //   if (projectCode[0] === 'F') {
    //     projectCodeSlice = projectCode.slice(1);
    //   } else if (projectCode[0] === 'J') {
    //     projectCodeSlice = projectCode.slice(2);
    //   } else {
    //     projectCodeSlice = projectCode;
    //   }
    // }
    const level = {level: 'projek', kod: projectCode};
    getPh({
      tahun: payload.tahun.value,
      jenisTanaman: payload.jenisTanaman,
      flag: 'click',
      status: 'publish',
      ...level,
    });
    getNpk({
      tahun: payload.tahun.value,
      jenisTanaman: payload.jenisTanaman,
      flag: 'click',
      status: 'publish',
      ...level,
    });
    getSyor();
  }, [payload]);

  return (
    <div className='patd_ctr'>
      <div className='patd_data_ctr'>
        <div className='patd_filter'>
          <div className='patd_toggle'>
            <div
              className={`patd_toggle_item ${
                payload.jenisTanaman === 'sawit' ? 'active' : ''
              }`}
              onClick={() =>
                setPayload((prev) => ({...prev, jenisTanaman: 'sawit'}))
              }
            >
              {newObj.SawitWord[language]}
            </div>
            <div
              className={`patd_toggle_item  ${
                payload.jenisTanaman === 'getah' ? 'active' : ''
              }`}
              onClick={() =>
                setPayload((prev) => ({...prev, jenisTanaman: 'getah'}))
              }
            >
              {newObj.GetahWord[language]}
            </div>
          </div>
          <div className='patd_year'>
            <RightDropdown
              selectedMenu={payload.tahun}
              onClick={(item) => {
                setPayload((prev) => ({...prev, tahun: item}));
              }}
              menu_list={years}
            />
          </div>
        </div>
        <div className='patd_doughnut_ctr'>
          <p className='patd_doughnut_text'>{title}</p>
          <div className='doughnut_chart'>
            <div className='doughnut_wrapper'>
              <DoughnutChart
                data={{
                  labels: ['Normal', 'Rendah'],
                  datasets: [
                    {
                      label: 'pH',
                      data: [data.ph?.normal, data.ph?.low],
                      backgroundColor: [
                        data.ph?.normalColor,
                        data.ph?.lowColor,
                      ],
                      hoverBackgroundColor: [
                        data.ph?.normalColor,
                        data.ph?.lowColor,
                      ],
                      borderColor: [data.ph?.normalColor, data.ph?.lowColor],
                      borderWidth: 1,
                    },
                  ],
                }}
                options={options}
              />
            </div>
            <div className='indicator'>
              <div className='indicator_item'>
                <div
                  className='indicator_color'
                  style={{backgroundColor: data.ph?.normalColor}}
                />
                <div className='indicator_content'>
                  <p className='indicator_text'>
                    {newObj.NormalWord[language]}
                  </p>
                  <p className='indicator_value'>{data.ph?.normal}</p>
                </div>
              </div>
              <div className='indicator_item'>
                <div
                  className='indicator_color'
                  style={{backgroundColor: data.ph?.lowColor}}
                />
                <div className='indicator_content'>
                  <p className='indicator_text'>{newObj.LowWord[language]}</p>
                  <p className='indicator_value'>{data.ph?.low}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='patd_npk_table_ctr'>
          {data.npk?.Status?.length > 0 && (
            <table className='table'>
              <thead>
                <tr>
                  <th style={{color: '#fff'}}>NPK</th>
                  {data.npk?.Status?.map((item) => (
                    <th>
                      <div
                        className='patd_th_wrapper'
                        style={{
                          backgroundColor: item.color,
                        }}
                      >
                        {item.name}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.npk?.Nutrien?.map((item) => (
                  <tr>
                    <td>
                      <div
                        className='patd_td_wrapper'
                        style={{
                          backgroundColor: item.color,
                        }}
                      >
                        {item.name}
                      </div>
                    </td>
                    {item.data.map((parameter, i) => (
                      <td
                        style={{
                          color: data.npk?.Status[i].color,
                        }}
                      >
                        {parameter}%
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <div className='patd_syor_table_ctr'>
        <p className='patd_syor_table_title'>Pengesyoran Baja</p>
        <div className='patd_syor_table'>
          {data.pengesyoran_baja?.length > 0 ? (
            data.pengesyoran_baja?.map((item) => (
              <div className='table_ctr'>
                <div className='table_head'>{item.namaProjek}</div>
                <table>
                  <thead>
                    <tr>
                      <th>Jenis Baja</th>
                      <th>
                        <p className='main'>Psg 1</p>
                        <p className='secondary'>kg/pkk</p>
                      </th>
                      <th>
                        <p className='main'>Psg 2</p>
                        <p className='secondary'>kg/pkk</p>
                      </th>
                      <th>
                        <p className='main'>Psg 3</p>
                        <p className='secondary'>kg/pkk</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {item?.jenis_baja.map((baja, i) => (
                      <tr>
                        <td>{baja?.name}</td>
                        <td>{item?.pusingan[0]?.Baja[i]?.baja_data || 0}</td>
                        <td>{item?.pusingan[1]?.Baja[i]?.baja_data || 0}</td>
                        <td>{item?.pusingan[2]?.Baja[i]?.baja_data || 0}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))
          ) : (
            <div style={{textAlign: 'center'}}>
              {newObj.NoDataWord[language]}
            </div>
          )}
        </div>
      </div>
      <div style={{padding: '10px'}}>
        {Object.keys(picData).length > 0 ? (
          <Box
          // style={{
          //   padding: '10px',
          // }}
          >
            <Box
              style={{
                backgroundColor: '#d9d9d9',
                borderRadius: '10px',
                width: '100%',
              }}
            >
              <Box
                onClick={() => {}}
                style={{
                  cursor: 'pointer',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '10px',
                  }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <img
                      src={Profile}
                      style={{marginRight: 10, width: '20px'}}
                      alt='pic'
                    />{' '}
                    <span
                      style={{
                        fontSize: '12px',
                      }}
                    >
                      PIC
                    </span>
                  </div>
                </div>
              </Box>

              <hr />

              <div
                style={{
                  padding: '10px 0px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    gap: '10px',
                    alignItems: 'center',
                    padding: '0px 10px 10px',
                  }}
                >
                  <img
                    src={IconProfile}
                    style={{
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                    }}
                    alt='pic_img'
                  />
                  <div>
                    <div
                      style={{
                        fontWeight: 'bold',
                        fontSize: '12px',
                        marginBottom: '5px',
                      }}
                    >
                      {picData.fullname}
                    </div>
                    <div style={{fontSize: '12px'}}>
                      {picData.jawatan}
                      <div style={{fontWeight: 'bold', fontSize: '12px'}}>
                        {/* {lintramaxData.net_weight_in_mt} */}
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div
                  style={{
                    fontSize: '12px',
                    padding: '15px 10px 5px',
                  }}
                >
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      style={{
                        fontSize: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                        marginBottom: '10px',
                      }}
                    >
                      <img src={IconTelephone} alt='icon_telephone' />
                      <div style={{fontSize: '12px'}}>{picData.contact}</div>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        fontSize: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                      }}
                    >
                      <img src={IconMail} alt='icon_mail' />
                      <div style={{fontSize: '12px'}}>{picData.email}</div>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </Box>
          </Box>
        ) : (
          <Box
          // style={{
          //   padding: '10px',
          // }}
          >
            <Box
              style={{
                backgroundColor: '#d9d9d9',
                borderRadius: '10px',
                width: '100%',
              }}
            >
              <Box
                onClick={() => {}}
                style={{
                  cursor: 'pointer',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '10px',
                  }}
                >
                  <div
                    style={{
                      fontWeight: 'bold',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <img
                      src={Profile}
                      style={{marginRight: 10, width: '20px'}}
                      alt='pic'
                    />{' '}
                    <span
                      style={{
                        fontSize: '12px',
                      }}
                    >
                      PIC
                    </span>
                  </div>
                </div>
              </Box>

              <hr />

              <div
                style={{
                  padding: '10px',
                }}
              >
                <div style={{padding: '10px', textAlign: 'center'}}>
                  {newObj.NoDataWord[language]}
                </div>
              </div>
            </Box>
          </Box>
        )}
      </div>
    </div>
  );
}
